import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { useState } from "react";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { CreateClientModal } from "./CreateClientModal";

export const NewClientButton = (): React.ReactNode => {
  const { t } = useResource();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setIsModalOpen(true)}
        sx={{ px: Spacing.L }}
      >
        {t(Resources.Common.NewClient)}
      </Button>
      <CreateClientModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
